import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {useScrollTrigger} from "@mui/material"
import {Breadcrumbs} from "models/SearchState"
import {checkIfMerchandisedUrl} from "@next/utils"
import {STICKY_HEADER_SCROLL_TRIGGER} from "../../config/constants"
import connect from "./connect"
import {httpUrlTrimmer} from "../../utils/httpUrlTrimmer"

export interface DesktopHeaderContainerProps {
    enableCentreTitle: boolean
    breadcrumbs: Breadcrumbs
    url: string
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: JSX.Element
    urlIsSaleOrClearance: boolean
}

const DesktopHeaderContainer = memo(
    ({
        enableCentreTitle,
        breadcrumbs,
        url,
        children,
        templating,
        urlIsSaleOrClearance,
    }: DesktopHeaderContainerProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)
        const isMerchandisedUrl = checkIfMerchandisedUrl(httpUrlTrimmer(url))
        const sticky = useScrollTrigger({threshold: STICKY_HEADER_SCROLL_TRIGGER})
        return (
            <ComponentName
                $urlIsSaleOrClearance={urlIsSaleOrClearance}
                $sticky={sticky}
                $enableCentreTitle={enableCentreTitle}
                $breadcrumbsEnabled={breadcrumbs.enabled}
                $isMerchandisedUrl={isMerchandisedUrl}
            >
                {children}
            </ComponentName>
        )
    },
)
DesktopHeaderContainer.displayName = "DesktopHeaderContainer"
export default connect(DesktopHeaderContainer)
